var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import Fuse from 'fuse.js';
import { useMemo, useState } from 'react';
import { useDebounceHandler } from './useDebounceHandler';
function getSearchResult(value, fuse) {
    if (value.length > 1) {
        var searchStr = value;
        if (value.startsWith('*')) {
            searchStr = "".concat(value.replace('*', ''), "$");
        }
        else if (value.endsWith('*')) {
            searchStr = "^".concat(value.replace('*', ''));
        }
        else if (value.includes(',')) {
            searchStr = "".concat(value
                .split(',')
                .map(function (v) { return v.trim(); })
                .join('|'));
        }
        var results = fuse.search(searchStr);
        return results.map(function (_a) {
            var item = _a.item;
            return item;
        });
    }
    else {
        return undefined;
    }
}
export default function useFuseSearch(list, options) {
    var _a = __read(useState(), 2), resultSet = _a[0], setResultSet = _a[1];
    var _b = __read(useState(''), 2), searchString = _b[0], setSearchString = _b[1];
    var fuse = useMemo(function () {
        return new Fuse(list, options);
    }, [list]);
    useDebounceHandler(function () { return setResultSet(getSearchResult(searchString, fuse)); }, searchString, 500);
    function searchChangeHandler(e) {
        var value = e.target.value;
        setSearchString(value);
    }
    function updateResultSet(updated) {
        setResultSet(updated);
    }
    return { searchString: searchString, resultSet: resultSet, searchChangeHandler: searchChangeHandler, setSearchString: setSearchString };
}
